var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStroy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 82,
    viewBox: "0 0 80 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.8409V65.8541L39.7981 48.8916L79.8235 65.8541V71.8409L39.7981 62.8607L0 71.8409Z",
    fill: "#E41170"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.125 81.6301V77.2219L39.7984 69.875L79.9989 77.2219V81.6301H39.7984H0.125Z",
    fill: "#E41170"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 60.8654V50.8875L39.9117 26.9404L79.8235 50.8875V59.8676L39.9117 41.9073L0 60.8654Z",
    fill: "#E41170"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 44.9007V38.914L39.9117 0L79.8235 41.9073V47.8941L39.9117 15.9647L0 44.9007Z",
    fill: "#E41170"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStroy);
export default __webpack_public_path__ + "static/media/stroy.9bb66824699b40ddea50a4f6d3e6e158.svg";
export { ForwardRef as ReactComponent };